import type { AppRouteRecordRaw } from "shared/types";

const routes: AppRouteRecordRaw[] = [];

export default routes;
